var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-page" },
    [
      _c("img", {
        staticClass: "bg-decoration",
        attrs: { src: "/static/domino.jpg", alt: "background decoration" }
      }),
      _vm._v(" "),
      _c(
        "b-container",
        {
          staticClass: "h-100 d-flex align-items-center justify-content-center"
        },
        [
          _c(
            "div",
            { staticClass: "login-card" },
            [
              _c("div", { staticClass: "text-center mb-4" }, [
                _c("div", { staticClass: "logo-container" }, [
                  _c("img", {
                    staticClass: "logo-login",
                    attrs: { src: "/static/logo.svg", alt: "Logo" }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-alert",
                {
                  staticClass: "custom-alert",
                  attrs: {
                    variant: "danger",
                    dismissible: "",
                    show: _vm.showDismissibleAlert
                  },
                  on: {
                    dismissed: function($event) {
                      _vm.showDismissibleAlert = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.loginErrorMessage) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-form",
                {
                  staticClass: "login-form",
                  attrs: { id: "loginForm" },
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("h2", { staticClass: "text-center mb-4 d-block" }, [
                    _vm._v("Войдите в аккаунт")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { staticClass: "custom-group mb-4" },
                    [
                      _c("b-form-input", {
                        staticClass: "custom-input",
                        attrs: {
                          id: "usernameInput",
                          type: "text",
                          placeholder: _vm.$t("message.login.enterLogin")
                        },
                        model: {
                          value: _vm.username,
                          callback: function($$v) {
                            _vm.username = $$v
                          },
                          expression: "username"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { staticClass: "custom-group mb-2 position-relative" },
                    [
                      _c("b-form-input", {
                        staticClass: "custom-input",
                        attrs: {
                          id: "passwordInput",
                          type: _vm.isPasswordVisible ? "text" : "password",
                          placeholder: _vm.$t("message.login.enterPassword")
                        },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "password-toggle",
                          on: {
                            click: function($event) {
                              _vm.isPasswordVisible = !_vm.isPasswordVisible
                            }
                          }
                        },
                        [
                          _vm.isPasswordVisible
                            ? _c("v-icon", {
                                attrs: { name: "buttons/eye", size: 16 }
                              })
                            : _c("v-icon", {
                                attrs: { name: "buttons/eyeClosed", size: 16 }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "password-description d-flex align-items-start mb-1 ml-3"
                    },
                    [
                      _c("v-icon", {
                        staticClass: "me-2 mr-1",
                        attrs: { name: "buttons/info", size: 12 }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "был выдан администратором, либо уже изменён вами в личном кабинете"
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-end align-items-center mb-5"
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          model: {
                            value: _vm.rememberToken,
                            callback: function($$v) {
                              _vm.rememberToken = $$v
                            },
                            expression: "rememberToken"
                          }
                        },
                        [_vm._v("\n            Запомнить меня\n          ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-submit",
                          attrs: { type: "submit", variant: "dark" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("message.login.signIn")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b6faab3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6faab3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Authorization/Login.vue
// module id = null
// module chunks = 